<template>
    <div class="CourseSeting">
        <BaseSet v-if="queryName == '基本设置'" ></BaseSet>
        <CourseChildren v-if="queryName == '课时列表'"></CourseChildren>
        <Report v-if="queryName == '课程报告'"></Report>
    </div>
</template>

<script>
    import BaseSet from "./components/BaseSet";
    import CourseChildren from "./components/CourseChildren";
    import Report from "./components/Report";
    import $Bus from "@/pages/projectImpl/js/eventBus"

    export default {
        name: 'CourseSeting',
        components: {BaseSet, CourseChildren, Report},
        data() {
            return {
                currentNav: 0,
                type: 'edit',
                queryName: this.$route.query.name
            }
        },
        mounted() {
            this.setTitle()
        },
        methods: {
            // 设置当前页面title
            setTitle() {
                const seriesInfo = this.$store.getters["course/getSeriesInfo"]();
                const courseInfo = this.$store.getters["course/getCourseInfo"]();
                if (this.queryName === "基本设置") {
                    $Bus.$emit("pageHeaderTitle", (seriesInfo.name || "") + (courseInfo.name ? " / " : "") + (courseInfo.name || ""));
                    if (typeof courseInfo === "object"){
                        // const arr = ["首页", "内容中心", {name: "课程管理", path: "/content/Course"}, {name: "课程详情", path: "/content/Course?type=3"}, "编辑课程"];
                        let arr = []
                        if(seriesInfo.status == 1){
                            arr = ["首页", "内容中心", {name: "课程管理", path: window.decodeURIComponent(this.$route.query.fullPath || "/course/manage?type=3")},"课程详情"];
                        }else{
                            arr = ["首页", "内容中心", {name: "课程管理", path: window.decodeURIComponent(this.$route.query.fullPath || "/course/manage?type=3")},"编辑课程"];
                        }

                        $Bus.$emit("pageHeaderBreadcrumb", arr);
                    } else {
                        const arr = ["首页", "内容中心", {name: "课程管理", path: window.decodeURIComponent(this.$route.query.fullPath || "/course/manage?type=3")}, "添加课程"];
                        $Bus.$emit("pageHeaderBreadcrumb", arr);
                    }
                    return
                } else {
                    $Bus.$emit("pageHeaderTitle", this.queryName);
                }
                const arr = ["首页", "内容中心", {name: "课程管理", path: window.decodeURIComponent(this.$route.query.fullPath || "/course/manage")}, this.queryName];
                $Bus.$emit("pageHeaderBreadcrumb", arr);
            }
        },
        beforeDestroy() {
            $Bus.$emit("pageHeaderTitle", false);
        }
    }
</script>
